import { useState as i, useCallback as m, useEffect as h } from "react";
import { i as d } from "./isClient-bZWD-rdJ.js";
import { g as o } from "./_commonjsHelpers-OnjxAlhP.js";
const u = (e) => {
  const n = (t) => {
    var a;
    return d ? !!((a = o().window) != null && a.matchMedia(t).matches) : !1;
  }, [r, c] = i(n(e)), s = m(() => {
    c(n(e));
  }, [e]);
  return h(() => {
    var a;
    const t = (a = o().window) == null ? void 0 : a.matchMedia(e);
    if (s(), t)
      return t.addEventListener("change", s), () => t.removeEventListener("change", s);
  }, [s, e]), r;
};
export {
  u
};
